module.exports = __webpack_public_path__ + "static/media/menu-3.c18ab399.png";